export default __webpack_public_path__ + "static/media/ketodrink@2x.63f6da4e.jpg";